// @flow

import Errors, { resourceNames } from 'app/errors';
import fetch, { fetchJson } from 'app/common/fetch';
import { BASE_V1_API_URL } from 'app/developer-v3/utils/constants';

export const loadAppEvents = (appId: string | number, filters: {}) => {
  const apiUrl = `${BASE_V1_API_URL}/apps/${appId}/events`;

  const url = fetch.url(apiUrl, filters);
  return fetchJson(url)
    .then(results => {
      return results?.events || [];
    })
    .catch(response => {
      throw new Errors.DataGetError({
        resource: resourceNames.devAppEvents,
        response,
      });
    });
};
